"use client";

import { TocHeading } from "@/lib/wordpress";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import TableOfContents from "./TableOfContents";
import SidebarCTA from "./SidebarCTA";

interface BlogContentProps {
  headings: TocHeading[];
  slug: string;
  children: React.ReactNode;
}

export default function BlogContent({ headings, slug, children }: BlogContentProps) {
  const [isTocOpen, setIsTocOpen] = useState(false);

  return (
    <div className="container pb-8 pt-24 lg:pb-12 lg:pt-28">
      {/* Mobile TOC - Collapsible */}
      {headings.length > 0 && (
        <div className="mb-8 lg:hidden">
          <button
            onClick={() => setIsTocOpen(!isTocOpen)}
            className="flex w-full items-center justify-between rounded-xl border border-gray-200 bg-white p-4"
          >
            <span className="font-crimsonText text-lg font-semibold text-[#02386D]">
              Table of Contents
            </span>
            <ChevronDown
              size={20}
              className={`text-gray-500 transition-transform duration-200 ${
                isTocOpen ? "rotate-180" : ""
              }`}
            />
          </button>
          {isTocOpen && (
            <div className="mt-2">
              <TableOfContents headings={headings} slug={slug} />
            </div>
          )}
        </div>
      )}

      {/* Desktop Layout - Two Columns */}
      <div className="lg:grid lg:grid-cols-[1fr_320px] lg:gap-12">
        {/* Blog Content - Left */}
        <article className="min-w-0">{children}</article>

        {/* Sidebar - Right (Desktop only) */}
        <aside className="hidden lg:block">
          <div className="sticky top-28 h-[calc(100vh-140px)] overflow-y-auto pr-1 custom-sidebar-scrollbar flex flex-col gap-4">
            {headings.length > 0 && <TableOfContents headings={headings} slug={slug} />}
            <SidebarCTA />
          </div>
        </aside>
      </div>

      {/* Mobile CTA - After content */}
      <div className="mt-12 lg:hidden">
        <SidebarCTA />
      </div>
    </div>
  );
}
